import styled from 'styled-components';

export const MetodeContainer = styled.div`
    height: 680px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #D6D6D6;

    @media screen and (max-width: 1000px) {
        height: 1000px;
    }

    @media screen and (max-width: 768px) {
        height: 1200px;
    }

    @media screen and (max-width: 480px) {
        height: 1300px;
    } 
`;

export const MetodeWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 0 50px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`;

export const MetodeCard = styled.div`
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 350px;
    padding: 30px;
    box-shadow: 0 1px 3px rgba( 0, 0, 0, 0.2 );
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 1000px) {
        max-height: 295px;
    }
`;

export const MetodeIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 10px;
`;

export const MetodeH1 = styled.h1`
    font-size: 2.5rem;
    color: #000;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }
`;

export const MetodeH2 = styled.h2`
    font-size: 1rem;
    margin-bottom: 10px;
`;

export const MetodeP = styled.p`
    font-size: 0.8rem;
    text-align: center;
`;
